import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import promptPlateFooterBg from "@/assets/prompt-plate-footer-bg.jpg";

export function DailyCircusBanner() {
  const location = useLocation();
  const isPromptAndPlatePage = location.pathname === '/prompt-and-plate';
  const handleClick = () => {
    if (isPromptAndPlatePage) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <Link to="/prompt-and-plate" className="block group w-full" onClick={handleClick}>
      <div className="w-full max-w-none sm:max-w-[500px] lg:max-w-[400px] xl:max-w-[500px] rounded-[18px] overflow-hidden shadow-lg border border-border transition-all duration-500 ease-out group-hover:scale-[1.02] group-hover:shadow-xl group-hover:shadow-primary/20 relative">
        {/* Background image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${promptPlateFooterBg})` }}
        />
        {/* Dark blue overlay matching Prompt & Plate hero */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/90 via-blue-900/85 to-slate-900/90" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(59,130,246,0.15),transparent_50%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(168,85,247,0.12),transparent_50%)]" />
        
        {/* Content */}
        <div className="relative z-10 p-6 sm:p-8 flex flex-col items-center text-center min-h-[200px] sm:min-h-[220px] justify-center gap-3">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
            <span className="text-white drop-shadow-[0_2px_10px_rgba(255,255,255,0.3)]">Prompt & </span>
            <span className="bg-gradient-to-r from-blue-300 via-purple-300 to-blue-300 bg-clip-text text-transparent">Plate</span>
          </h2>
          <p className="text-base sm:text-lg text-white/90 leading-tight">
            Where AI meets authentic conversation over lunch  
          </p>
          <Button variant="hero" size="sm" className="shadow-[0_10px_30px_-10px_hsl(var(--primary)_/_0.4)] group-hover:shadow-[0_15px_40px_-10px_hsl(var(--primary)_/_0.5)]">
            Request a free seat
          </Button>
        </div>
      </div>
    </Link>;
}